export default "__VITE_ASSET__998a7f86__"